<style lang="scss">
.AuthorizerFormReset {
  &__forget {
    background: lightyellow;
    font-size: .875rem;
    text-align: right;
    color: inherit;
  }
}
</style>

<template>
<form
  class="AuthorizerForm AuthorizerFormReset"
  name="authorizer-reset"
  @submit.prevent="submit">

  <div class="AuthorizerForm__fieldset">

    <InputText class="input-text"
      name="auth-login"
      autocomplete="email"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="Email or phone"
      v-model="modelValue"
      @input="$emit('update:modelValue', modelValue)"/>

  </div>

  <div class="AuthorizerForm__submit">
    <button class="button" @click.prevent="submit">
      <span>Continue</span>
    </button>
  </div>

</form>
</template>

<script>
import {AuthAction} from './Authorizer.vue';
import InputText from '@/components/input-text/InputText.vue';
export default {
  name: 'AuthorizerReset',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  components: {
    InputText,
  },
  methods: {
    async submit() {
      const {modelValue: login} = this;
      // const {data, error} = await this.$store.dispatch('user/passwordReset', {login});
      console.log('RESET', login);
      this.$parent.authAction = AuthAction.verify;
    },
  },
}
</script>
